import React from 'react'
import { SectionBanner } from './section-banner'
import { SectionAccordion } from './section-accordion'

const MainContent = () => {
  return <>
    <SectionBanner />
    <SectionAccordion />
  </>
}

export { MainContent }
